import { Component, ElementRef, Input, OnInit, ViewChild, Output, EventEmitter, OnDestroy, effect } from '@angular/core';
import * as moment from 'moment';
import * as _ from 'lodash';
import { Subscription } from 'rxjs';
import { AppStateService } from 'src/app/shared/services/helpers/app-state.service';
import { NgIf, NgStyle, NgFor, NgClass } from '@angular/common';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-score-widget',
    templateUrl: './score-widget.component.html',
    styleUrl: './score-widget.component.scss',
    imports: [NgIf, NgStyle, NgFor, NgClass, NgbTooltip]
})
export class ScoreWidgetComponent implements OnInit, OnDestroy {
  @ViewChild('dropdownContainer') dropdownContainer!: ElementRef;
  isTrendDropdownShow: boolean = false;
  isAbsoluteChartShow: boolean = false;
  isAbsoluteChartActive: boolean = true;
  isPercenttageChartShow: boolean = false;
  isPercenttageChartActive: boolean = false;
  isDownloadButtonShow: boolean = false;
  isFullScreenButtonShow: boolean = false;
  selectedOption: string = '';
  selectedField: any = '';
  isDropdownOpen: boolean = false;
  options: any = [];
  isFullscreen: boolean = false;
  @Output() onFullscreenClick: any = new EventEmitter<any>();
  @Output() onTrendClick: any = new EventEmitter<any>();
  @Output() onDownloadClick: any = new EventEmitter<any>();
  @Output() onChartTypeChange: any = new EventEmitter<any>();
  isOpen: boolean = false;
  downloadList: any = [];
  
  private _config: any;

  @Input('config')
  set config(value: string) {
    this._config = value;
    this.execute(this._config);
  }

  @Input('fullScreenButtonControl')
  set fullScreenButtonControl(value: boolean) {
    this.isFullscreen = value;
  }

  get npsValue(): string {
    return this._config;
  }

  private subscriptions: Subscription = new Subscription();

  constructor(
    private appStateService: AppStateService,
  ) {
    effect(() => {
      if (this.appStateService.initialized()) {
        const datePicker = this.appStateService.datePicker();
        this.options = [];
        const startDate = moment(datePicker['startDate'], 'YYYYMMDD');
        const endDate = moment(datePicker['endDate'], 'YYYYMMDD');
        const dataFilterType = datePicker['dateFilterType'];
        const label = dataFilterType == 1 ? 'Request' : 'Response';
        const numberOfDays = endDate.diff(startDate, 'days') + 1;
        if (numberOfDays <= 1) {
          this.options.push({ name: 'Hourly', display: label + ' Time', trend_type: 0 });
        } else if (numberOfDays <= 7) {
          this.options.push({ name: 'Daily', display: label + ' Date', trend_type: 1 });
        } else if (numberOfDays <= 31) {
          this.options.push({ name: 'Daily', display: label + ' Date', trend_type: 1 }, { name: 'Weekly', display: label + ' Week (Start Date)', trend_type: 2 });
        } else if (numberOfDays <= 92) {
          this.options.push({ name: 'Weekly', display: label + ' Week (Start Date)', trend_type: 2 }, { name: 'Monthly', display: label + ' Month', trend_type: 3 })
        } else if (numberOfDays <= 366) {
          this.options.push({ name: 'Weekly', display: label + ' Week (Start Date)', trend_type: 2 }, { name: 'Monthly', display: label + ' Month', trend_type: 3 }, { name: 'Quarterly', display: label + ' Quarter', trend_type: 4 });
        } else {
          this.options.push({ name: 'Monthly', display: label + ' Month', trend_type: 3 }, { name: 'Quarterly', display: label + ' Quater', trend_type: 4 }, { name: 'Yearly', display: label + ' Year', trend_type: 5 });
        }
        this.selectedField = this.options[0]?.trend_type;
        this.selectedOption = this.options[0]?.name;
        this.onTrendClick.emit(this.options[0]);
      }
    });
  }

  ngOnInit(): void {
  }

  // to block multiple event firing
  // checkRequiredParameter(params:any){
  //     if(params && _.hasIn(params,'datePicker.startDate') && _.hasIn(params,'datePicker.endDate')){
  //       return true
  //     }else{
  //       return false
  //     }
  // }

  execute(event: any) {
    this.isTrendDropdownShow = event.isTrendDropdownShow;
    this.isAbsoluteChartShow = event.isAbsoluteChartShow;
    this.isPercenttageChartShow = event.isPercenttageChartShow;
    this.isDownloadButtonShow = event.isDownloadButtonShow;
    this.isFullScreenButtonShow = event.isFullScreenButtonShow;
    // Sync toggle highlight from parent when provided (Question tab shares Absolute/Percentage across question types).
    if (event && Object.prototype.hasOwnProperty.call(event, 'isPercenttageChartActive')) {
      this.isPercenttageChartActive = !!event.isPercenttageChartActive;
      this.isAbsoluteChartActive = !this.isPercenttageChartActive;
    }
  }

  onButtonClick(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
    if (this.isDropdownOpen) {
      document.addEventListener('click', this.handleClickOutside);
    } else {
      document.removeEventListener('click', this.handleClickOutside);
    }
  }

  onOptionClick(event: any): void {
    if(this.selectedField === event?.trend_type) {
      return;
    }
    this.selectedField = event?.trend_type;
    this.isDropdownOpen = false;
    this.selectedOption = event?.name;
    this.onTrendClick.emit(event);
  }

  handleClickOutside = (event: MouseEvent) => {
    const widgetContainer: any = this.dropdownContainer.nativeElement;
    if (widgetContainer && !widgetContainer.contains(event.target as Node)) {
      this.isDropdownOpen = false;
      document.removeEventListener('click', this.handleClickOutside);
    }
  };

  onFullscreen(event?: any) {
    if(event){
      event.stopPropagation();
      event.preventDefault();
    }
    this.isFullscreen = !this.isFullscreen;
    this.onFullscreenClick.emit(this.isFullscreen);
  }

  onDownloadButtonClick(event:any): void {
    event.stopPropagation();
    this.onDownloadClick.emit();
  }

  toggleGraphScale(type: string): void {
    if(type === 'absoluteChart') {
      this.isPercenttageChartActive = false;
      this.isAbsoluteChartActive = true;
    } else if(type === 'percentageChart') {
      this.isPercenttageChartActive = true;
      this.isAbsoluteChartActive = false;
    }
    this.onChartTypeChange.emit(this.isPercenttageChartActive);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}